const navigationEventTracker = (trackingData) => {
  var eventOptions = Object.assign({
    'menu_type': trackingData.menu_type,
    'navigation_menu': trackingData.label_for_tracking,
    'expandable': trackingData.expandable
  }, trackingData?.tracking_options);
  ChrAnalytics.trackEvent(chrEventConstants.action.INTERACTED_NAVIGATION_MENU, eventOptions);
}

export default navigationEventTracker
